<template>
  <div class="contentBox">
    <div class="breadCrumbs mt-50">
      <el-breadcrumb separator="/" class="ml-15">
        <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
        <el-breadcrumb-item>opportunities</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="opportunities">
      <p class="title"></p>
      <div class="opportunitiesbox">
        <el-tabs type="border-card">
          <el-tab-pane>
            <span slot="label">
              <i class="el-icon-document"></i> Introduction
            </span>
            <div v-html='opportunities'></div>
          </el-tab-pane>
          <el-tab-pane label="Album">
            <span slot="label">
              <i class="el-icon-picture-outline"></i> Album
            </span>
            <div class="imgListBox">
              
              <ul class="imgUl">
                <li v-for="(item,key) in imgList" :key = 'key'  >
                  <img :src='item.src' :preview="key" :preview-text="item.title"/>
                  <p class="title">{{item.title}}</p>
                  <p class="maintext">{{item.description}}</p>
                  <p class="tips"><span class="sp1"><i class="el-icon-time"></i>{{item.shoot_date}}</span></p>
                </li>
              </ul>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import apiSign from "../assets/js/apiSign";
import "@/assets/css/opportunities.less";
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
Vue.use(preview)
export default {
  data() {
    return {
      list: [
        {
          src: "https://placekitten.com/600/400",
          w: 600,
          h: 600
        },
        {
          src: "https://placekitten.com/1200/900",
          w: 1200,
          h: 900
        }
      ],
      imgList: [],
      opportunities:''
    };
  },
  created() {
    this.getImgList();
  },
  methods: {
    getImgList() {
      let field = { rtime: apiSign.getTime() };
      this.axios.get(this.axios.defaults.baseURL +'/yiwei/app/opportunities',{
        headers: {
            sign: apiSign.sign(field)
          },
          params: field
      }).then(resp=>{
        this.opportunities = resp.data.data.opportunities
      })
      this.axios
        .get(this.axios.defaults.baseURL + "/yiwei/album/lists", {
          headers: {
            sign: apiSign.sign(field)
          },
          params: field
        })
        .then(resp => {
          let respList = resp.data.data.data;
          // this.imgList = resp.data.data.data;
          let imgList = [];
          Object.keys(respList).forEach(key => {
            let imgDict = {};
            imgDict["src"] = respList[key].image;
            imgDict["title"] = respList[key].title;
            imgDict["description"] = respList[key].description;
            imgDict["shoot_date"] = respList[key].shoot_date;
            imgList.push(imgDict);
          });
          this.imgList = imgList;
          this.$previewRefresh()
        });
    },

    show(index) {
     
    },
    handleClose() {
      console.log("close event");
    },
    // 即将关闭的时候，调用这个处理函数
    closeHandler() {
      console.log("closeHandler");
    },
    // 完全关闭之后，调用这个函数清理资源
    destroyHandler() {
      console.log("destroyHandler");
    }
  }
};
</script>
<style>
.opportunitiesbox {
  background: #f7fdfb;
  padding: 20px;
  border-radius: 5px;
}
</style>
